import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { getColor, StyleVars } from 'core/utils';
import Lock from 'core/icons/Lock';
import Logo from 'core/icons/Logo';
import UserIcon from 'core/icons/UserIcon';

const Wrapper = styled.div`
	border-bottom: 1px solid ${getColor('mystic')};
	box-shadow: 0px 2px 4px 0px #3333331A;
`;

const Content = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;

	@media (min-width: ${StyleVars.screenSm}) {
		justify-content: flex-start;
	}

	max-width: ${StyleVars.screenCjDesktopMd};
	margin: 0 auto;
	padding-top: 24px;
	padding-bottom: 24px;
	padding-left: 16px;
	padding-right: 16px;
`;

const BadgeWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	@media (min-width: ${StyleVars.screenSm}) {
		flex: 1;
	}
`;

const NoteBadge = styled.span`
	display: flex;
	align-items: center;
	color: ${getColor('shuttleGray')};
	font-weight: 600;
	padding: 0 4px;

	@media (min-width: ${StyleVars.screenSm}) {
		margin: 0 16px 0 48px;
	}

	svg {
		margin-right: 8px;
	}

	${props => props.$mobileHidden && css`
		@media (max-width: ${StyleVars.desktopScreenSm}) {
			/* Hide on mobile */
			display: none;
		}
	`}
`;

const Link = styled.a`
	display: flex;
	color: inherit;
`;

const MiniHeader = ({ firstName, guest, registered }) => {
	const accountLink = guest && !registered ? "/customer/password_reset" : "/account/my_subscriptions/";
	return (
		<Wrapper>
			<Content>
				<Link href="/">
					<Logo />
				</Link>
				<BadgeWrap>
					<NoteBadge>
						<Lock width={16} height={16} fill={getColor('shuttleGray')} />
						Secure Checkout
					</NoteBadge>
					<NoteBadge $mobileHidden>
						<Link href={accountLink} target="_blank">
							<UserIcon stroke="currentColor" />
							{firstName}
						</Link>
					</NoteBadge>
				</BadgeWrap>
			</Content>
		</Wrapper>
	);
};

MiniHeader.propTypes = {
	firstName: PropTypes.string,
	guest: PropTypes.bool, // is guest checkout
	registered: PropTypes.bool, // is guest checkout for "registered" user
};

MiniHeader.defaultProps = {
	firstName: "Guest",
};

export default MiniHeader;
